import React, {Component} from 'react';



export default class Header extends Component {
    render(){
        return (
<footer class="sticky-footer bg-white">
    <div class="container my-auto">
        <div class="copyright text-center my-auto">
            <span>Copyright &copy; TydaEnergy 2023</span>
        </div>
    </div>
</footer>


)
}
}

